export const translations = {
  fr: {
    nav: {
      services: "Services",
      offers: "Tarifs",
      why: "Pourquoi moi",
      about: "À propos",
      contact: "Contact",
      blog: "Conseils",
      cta: "Être rappelé",
    },
    hero: {
      overline: "Smart SN · Partenaire indépendant Orange Belgium & Eneco",
      line1: "Votre connexion.",
      line2: "Votre énergie.",
      line3: "Un seul expert.",
      sub: "Depuis 10 ans, j'accompagne les foyers belges vers les meilleurs abonnements mobile, internet et TV d'Orange — et vers une énergie plus intelligente avec Eneco.",
      cta1: "Obtenir mon offre gratuite",
      cta2: "Découvrir les services",
      trustPartner: "Partenaire officiel Orange & Eneco",
      trustReviews: "avis Google",
      stats: [
        { v: "10+", l: "années d'expérience" },
        { v: "2", l: "fournisseurs premium" },
        { v: "100%", l: "suivi personnalisé" },
      ],
    },
    exitIntent: {
      title: "Attendez, une seconde !",
      sub: "Sam vous rappelle gratuitement sous 24h avec la meilleure offre pour vous — sans engagement.",
      name: "Votre prénom",
      phone: "Votre numéro",
      cta: "Rappelez-moi gratuitement",
      no: "Non merci, je continue ma visite",
      thanks: "C'est noté ! Sam vous rappelle sous 24h. À très vite 👋",
    },
    marquee: ["Orange Belgium", "Eneco", "Internet & 5G", "Packs Mobile + Internet", "Énergie verte", "Conseil indépendant"],
    manifesto: {
      overline: "Le manifeste",
      title: "Trois raisons de me faire confiance",
      chapters: [
        {
          n: "01",
          title: "Expertise",
          text: "Dix ans sur le terrain avec Smart SN, partenaire d'Orange Belgium. Je connais chaque pack, chaque option, chaque promotion — et surtout celle qui vous convient.",
        },
        {
          n: "02",
          title: "Indépendance",
          text: "Je ne suis pas un call-center. Je compare objectivement les offres télécom et énergie pour vous proposer la solution la plus rentable, sans langue de bois.",
        },
        {
          n: "03",
          title: "Proximité",
          text: "Basé en Belgique, je vous parle en français ou en anglais — avant, pendant et après la signature. Un seul interlocuteur, joignable directement.",
        },
      ],
    },
    services: {
      overline: "Ce que je vends",
      title: "Télécom & énergie, réunis",
      cta: "Demander une offre",
      orange: {
        tag: "Orange Belgium",
        title: "Mobile, Internet & TV",
        desc: "Des abonnements mobiles 5G, l'internet ultra-rapide et la TV réunis dans des packs combinés qui font baisser la facture.",
        bullets: ["Abonnements mobile 5G", "Internet ultra-rapide", "TV & divertissement", "Packs Mobile + Internet + TV"],
      },
      eneco: {
        tag: "Eneco",
        title: "Électricité & Gaz",
        desc: "Des contrats d'énergie clairs, verts et compétitifs pour votre habitation. Je compare et je vous installe le meilleur tarif.",
      },
      small: [
        { title: "Mobile 5G", desc: "Data généreuse, réseau primé en Belgique." },
        { title: "Internet + TV", desc: "Internet ultra-rapide, wifi puissant et divertissement complet." },
        { title: "Énergie verte", desc: "Électricité et gaz au meilleur tarif du moment." },
      ],
      whyOrange: {
        title: "Pourquoi choisir Orange ?",
        points: [
          "Un réseau rapide et fiable",
          "Des prix compétitifs",
          "Un service client humain, réactif et personnalisé",
          "Un accompagnement dédié, directement par moi, du début à la fin",
        ],
      },
    },
    offersSection: {
      overline: "Tarifs",
      title: "Les offres du moment",
      sub: "Prix indicatifs actuels — je verrouille la meilleure promotion au moment de la signature.",
      orange: "Orange Belgium",
      eneco: "Eneco",
      cta: "Obtenir cette offre",
      note: "Les prix évoluent souvent : je confirme le meilleur tarif actuel lors de notre appel.",
      countdownLabel: "Promos valables jusqu'au",
      endsIn: "Se termine dans",
    },
    calculator: {
      overline: "Simulateur",
      title: "Calculez votre pack",
      sub: "Choisissez votre internet et votre mobile — toutes les promos et avantages du moment sont appliqués automatiquement.",
      internet: "Internet",
      mobile: "Mobile",
      mixHint: "mixez les abonnements librement",
      base: "Prix catalogue",
      advantage: "Avantage multi-produits",
      lifetime: "Promos À VIE",
      temp: "Promos temporaires",
      perMonth: "/mois",
      forLife: "prix garanti À VIE",
      during: "pendant",
      months: "mois",
      then: "puis",
      save: "Vous économisez",
      cards: "Nombre de cartes SIM",
      multiCardNote: "Avantage multi-produits appliqué sur chaque carte mobile du pack !",
      compareCatalog: "Prix catalogue",
      compareDeal: "Votre prix À VIE",
      compareSave: "Vous économisez €{y}/an — à vie !",
      fixed: "Téléphone fixe (optionnel)",
      fixedNone: "Sans ligne fixe",
      fixedName: "Ligne fixe",
      fixedDetail: "Appels illimités vers les fixes belges",
      forLifeShort: "À VIE",
      tv: "Télévision",
      tvNone: "Sans TV",
      tvNoneDetail: "Internet + mobile uniquement",
      promoPeriod: "période promo",
      note: "Cartes supplémentaires et options TV incluses au calcul — prix final confirmé par Sam selon votre adresse et le réseau disponible.",
      cta: "Recevoir cette offre",
      share: "Partager sur WhatsApp",
      shareText: "Regarde le pack que j'ai simulé chez Smart Telecom Advisor :",
      copyLink: "Copier le lien",
      linkCopied: "Lien du pack copié !",
    },
    enecoTeaser: {
      overline: "Énergie",
      title: "Et si vous payiez moins pour votre énergie ?",
      text: "Indiquez votre consommation annuelle : obtenez une première estimation Eneco (électricité 100% verte & gaz) immédiatement. Sam affine ensuite la simulation gratuitement avec les tarifs exacts de votre région.",
      free: "Simulation gratuite et sans engagement",
      cta: "Recevoir ma simulation précise",
      modeBoth: "Électricité + Gaz",
      modeElec: "Électricité",
      modeGas: "Gaz",
      elecLabel: "Électricité (kWh/an)",
      gasLabel: "Gaz (kWh/an)",
      meterLabel: "Type de compteur électricité",
      meterMono: "Mono-horaire",
      meterBi: "Bi-horaire (jour / nuit)",
      meterBiShort: "bi-horaire",
      dayLabel: "Jour (kWh/an)",
      nightLabel: "Nuit / week-end (kWh/an)",
      nightHint: "Tarif nuit plus avantageux (~12 c€/kWh)",
      solarLabel: "Panneaux solaires",
      injLabel: "Injection réseau (kWh/an)",
      injHint: "Crédit d'injection ~4 c€/kWh (déjà déduit du total)",
      injLine: "Injection solaire",
      avgElec: "Moyenne belge : 3 500 kWh/an",
      avgGas: "Moyenne belge : 17 000 kWh/an",
      result: "Votre estimation Eneco",
      elecLine: "Électricité",
      gasLine: "Gaz",
      perMonth: "/mois",
      yr: "an",
      feeNote: "redevance de €65/an par énergie incluse",
      tariffFix: "Fix One · prix fixe 1 an",
      tariffFlex: "Flex One · prix variable",
      sohoLabel: "Indépendant / SOHO",
      feeNoteSoho: "redevance SOHO de €95/an par énergie incluse",
      promoBanner: "🔥 Promo octobre : −100€/EAN sur Fix One, −50€/EAN sur Flex One (contrats signés du 1 au 31/10) — combinables élec + gaz !",
      promoShort: "Promo octobre",
      promoLine: "Promo octobre (−{a}€ par EAN)",
      firstYear: "1re année ≈ €{y}, soit €{m}/mois",
      currentLabel: "Ce que vous payez actuellement (€/mois — optionnel)",
      cpLabel: "Code postal (Belgique)",
      cpPlaceholder: "Ex : 1000, 4000, 9000…",
      cpInvalid: "Code postal belge invalide (1000–9999).",
      regionLabel: "Zone :",
      regionNote: "tarifs réseau régionaux pris en compte",
      regions: { brussels: "Bruxelles", wallonia: "Wallonie", flanders: "Flandre" },
      currentPlaceholder: "ex. 180",
      currentShort: "actuellement",
      saving: "Économie potentielle : ≈ €{y}/an (€{m}/mois) !",
      noSaving: "Votre tarif actuel semble déjà compétitif — Sam vérifie gratuitement si Eneco peut faire mieux.",
      disclaimer: "Estimation indicative (énergie + redevance, tarifs réseau régionaux estimés via votre code postal, hors TVA). Sam vous fournit la simulation exacte gratuitement, basée sur votre facture.",
    },
    booking: {
      title: "Réserver un appel",
      subtitle: "Choisissez le moment qui vous arrange — Sam vous appelle, c'est gratuit.",
      name: "Votre nom",
      phone: "Votre téléphone",
      email: "E-mail (optionnel — pour recevoir un rappel avant l'appel)",
      cta: "Confirmer mon rendez-vous",
      booking: "Réservation…",
      success: "C'est noté ! Sam vous appelle",
      invalid: "Choisissez un créneau et indiquez votre nom + téléphone.",
      taken: "Ce créneau vient d'être pris, choisissez-en un autre.",
      failed: "Échec de la réservation, réessayez.",
      vacation: "Sam est en congé jusqu'au {d} — choisissez un créneau après son retour, ou laissez un message via le formulaire.",
    },
    soho: {
      overline: "Indépendants & TVA",
      title: "Des avantages exclusifs pour les pros",
      text: "Vous avez un numéro de TVA ? Profitez d'offres réservées aux indépendants et petites entreprises — avec le même service humain et personnalisé pendant toute la durée du contrat.",
      points: [
        "My Comfort Service gratuit pendant 12 mois : optimisation sur mesure de votre connexion internet",
        "Avantage multi-produits accessible avec votre pack Mobile + Internet",
        "Un seul interlocuteur dédié pour votre télécom et votre énergie",
      ],
      cta: "Parlons de votre activité",
    },
    testimonials: {
      overline: "Avis clients",
      title: "Ils me font confiance",
      leaveTitle: "Vous êtes client ? Laissez votre avis",
      yourName: "Votre nom",
      yourReview: "Votre expérience avec Sam…",
      submit: "Envoyer mon avis",
      thanks: "Merci ! Votre avis sera publié après validation par Sam.",
      moderation: "Les avis sont validés avant publication.",
      photoLabel: "Ajouter une photo (optionnel)",
      photoUploading: "Envoi…",
      photoAttached: "Photo ajoutée ✓",
      videoLabel: "Ajouter une vidéo (optionnel)",
      videoUploading: "Envoi vidéo…",
      videoAttached: "Vidéo ajoutée ✓",
      videoTooBig: "Vidéo trop lourde (max 60MB)",
      videoWall: "Avis vidéo",
      googleOn: "sur Google",
      googleReviews: "avis",
    },
    referral: {
      overline: "Parrainage",
      title: "Recommandez autour de vous. Économisez jusqu'à -100%.",
      text: "Réduction exclusive de 5% sur votre abonnement mobile, par mois et à vie, par référence qui souscrit un produit mobile Orange. Et comme toujours — un service humain et personnalisé pendant toute la durée de votre contrat.",
      per: "par référence qui souscrit un mobile Orange",
      max: "de réduction avec 20 références",
      highlight: "20 références = 100% de réduction sur un des numéros de votre facture mobile !",
      cta: "Je veux en profiter",
      shareLabel: "Partagez le site autour de vous :",
      shareText: "Découvre Smart Telecom Advisor — le meilleur des abonnements Orange (mobile, internet, TV) et de l'énergie Eneco, avec un conseiller dédié :",
      shareWhatsapp: "Partager sur WhatsApp",
      shareEmail: "Partager par e-mail",
      shareSubject: "À découvrir : Smart Telecom Advisor",
    },
    about: {
      overline: "À propos",
      title: "10 ans de confiance avec Smart SN",
      text: "Je m'appelle Sam et je suis conseiller indépendant au sein de Smart SN, branche d'Orange Belgium, depuis 10 ans. Mon travail : trouver pour chaque client belge la meilleure combinaison télécom et énergie — Orange pour la connexion, Eneco pour l'électricité et le gaz.",
      points: ["Conseiller indépendant certifié", "Service en français & anglais", "Service humain et personnalisé pendant toute la durée du contrat"],
    },
    form: {
      overline: "Contact",
      title: "Parlons de votre offre",
      sub: "Laissez vos coordonnées — je vous rappelle sous 24h avec une proposition concrète.",
      name: "Nom complet",
      email: "E-mail",
      phone: "Téléphone",
      city: "Commune",
      postal: "Code postal (ex : 4000)",
      interest: "Je suis intéressé par",
      options: {
        mobile: "Abonnement mobile",
        pack: "Pack Internet + TV",
        energy: "Électricité / Gaz (Eneco)",
        both: "Télécom + Énergie",
        other: "Autre / Je ne sais pas encore",
      },
      message: "Votre message (optionnel)",
      referredBy: "Parrainé par (nom du client — optionnel)",
      simLabel: "Pack simulé attaché",
      responseBadge: "Rappel moyen : sous {h}h",
      billLabel: "Joindre votre facture d'énergie (optionnel — PDF ou photo)",
      billUploading: "Envoi en cours…",
      billError: "Échec de l'envoi, réessayez.",
      billAnalyzing: "Analyse de votre facture en cours…",
      billTeaser: "Bonne nouvelle : vous pourriez économiser ≈ €{x}/mois avec Eneco ! Sam vous le confirme lors de son appel.",
      submit: "Envoyer ma demande",
      sending: "Envoi…",
      successTitle: "Merci !",
      successText: "Votre demande est bien reçue. Je vous recontacte très vite avec une offre sur mesure.",
      again: "Envoyer une autre demande",
      error: "Une erreur est survenue. Veuillez réessayer.",
      phoneDirect: "Vous préférez parler directement ? Le formulaire ne prend qu'une minute.",
    },
    chat: {
      title: "Assistant Smart TA",
      subtitle: "Réponses instantanées · FR & EN",
      welcome: "Bonjour ! Je peux vous renseigner sur les offres Orange (mobile, internet, TV) et Eneco (électricité, gaz). Que cherchez-vous ?",
      placeholder: "Écrivez votre message…",
    },
    seo: {
      title: "Votre conseiller Orange Belgium & Eneco partout en Belgique",
      h1: "Packs internet + GSM Orange Belgique",
      p1: "Distributeur indépendant Orange Belgium, je compare pour vous les abonnements mobile, internet, TV et ligne fixe. Profitez de la promo du moment avec −15€/mois À VIE sur l'internet Livebox Giga, la portabilité gratuite de votre numéro et un changement d'opérateur sans aucune démarche. Simulation de pack gratuite en ligne en 2 minutes.",
      h2: "Simulation électricité & gaz Eneco",
      p2: "Comparez votre facture d'énergie avec les tarifs Eneco adaptés à votre région : simulation gratuite électricité et gaz en Belgique selon votre code postal, votre type de compteur (mono-horaire ou bi-horaire) et vos panneaux solaires. Changer de fournisseur d'énergie est gratuit, sans coupure et je m'occupe de tout.",
      h3: "Conseiller télécom indépendant 100% gratuit",
      p3: "Service entièrement gratuit à Bruxelles, en Wallonie et en Flandre : analyse de votre facture télécom ou énergie, rendez-vous téléphonique sous 24h et suivi personnalisé après souscription. Réduisez votre facture télécom et énergie sans changer vos habitudes — en français ou en anglais.",
    },
    blog: {
      metaTitle: "Conseils télécom & énergie Belgique — Blog | Smart Telecom Advisor",
      metaDesc: "Guides pratiques pour payer moins : choisir son pack Orange, simuler l'électricité et le gaz Eneco, réduire sa facture télécom et énergie en Belgique.",
      overline: "Blog & conseils",
      title: "Conseils pour payer moins",
      subtitle: "Guides pratiques télécom & énergie pour la Belgique : packs Orange, simulation Eneco et astuces pour réduire vos factures.",
      read: "5 min de lecture",
      back: "Retour au site",
      ctaBtn: "Démarrer ma simulation gratuite",
      more: "À lire aussi",
    },


    footer: {
      tagline: "Conseiller indépendant télécom & énergie — Belgique",
      agent: "Espace agent",
      hours: "Lun–Sam · 9:00–19:00",
      support: "Support après-vente",
      googleReviews: "Nos avis Google",
      rights: "© 2026 Smart TA. Tous droits réservés.",
      disclaimer: "Smart TA est un partenaire indépendant d'Orange Belgium. Orange et Eneco sont des marques de leurs propriétaires respectifs.",
    },
    login: {
      title: "Espace agent",
      sub: "Connectez-vous pour gérer vos leads",
      email: "E-mail",
      password: "Mot de passe",
      submit: "Se connecter",
      loading: "Connexion…",
      error: "Identifiants invalides. Réessayez.",
      back: "Retour au site",
    },
    dash: {
      title: "Tableau de bord",
      subtitle: "Vos leads, qualifiés par IA",
      logout: "Déconnexion",
      refresh: "Actualiser",
      stats: { total: "Leads totaux", fresh: "Nouveaux", hot: "Leads chauds", converted: "Convertis" },
      cols: { client: "Client", contact: "Contact", interest: "Intérêt", score: "Score IA", summary: "Analyse IA", status: "Statut", actions: "" },
      statuses: { new: "Nouveau", contacted: "Contacté", converted: "Converti", lost: "Perdu" },
      empty: "Aucun lead pour le moment. Partagez votre site !",
      pending: "Analyse en cours…",
      scores: { hot: "Chaud", warm: "Tiède", cold: "Froid", pending: "…" },
      nextAction: "Action conseillée",
      delete: "Supprimer",
      referredBy: "Parrainé par",
      viaChat: "via chat",
      hotReply: "a répondu",
      bill: "Facture",
      pdfBrief: "Fiche PDF",
      proposalPdf: "Proposition client (PDF)",
      sendProposal: "Envoyer la proposition par e-mail",
      proposalSent: "Proposition envoyée à",
      proposalSentOn: "Envoyée le",
      proposalFailed: "Échec de l'envoi, réessayez.",
      winRates: {
        title: "Taux de conversion",
        sources: "Par source",
        interests: "Par intérêt",
        packs: "Par pack simulé",
        form: "Formulaire",
        chat: "Chatbot",
        empty: "Pas encore de données",
      },
      revenue: {
        title: "Revenus récurrents",
        mrr: "Valeur mensuelle actuelle",
        perMonth: "/mois",
        perYear: "/an",
        tooltip: "Valeur cumulée",
        empty: "Ajoutez une valeur €/mois à vos leads convertis (colonne Statut) pour suivre vos revenus.",
        goalTitle: "Objectif du mois",
        noGoal: "Définissez un objectif mensuel pour suivre votre progression.",
        goalPlaceholder: "ex. 100",
        goalSave: "Définir",
      },
      importCsv: "Importer CSV",
      importHint: "Colonnes : nom, téléphone, email, commune, valeur, statut",
      importDone: "client(s) importé(s)",
      importDupes: "doublon(s) ignoré(s)",
      importFailed: "Échec de l'import, vérifiez le fichier CSV.",
      details: {
        birthday: "Anniversaire (vœux automatiques)",
        contractEnd: "Fin de contrat (rappel 30 j avant)",
        failed: "Échec de l'enregistrement.",
      },
      renewal: {
        badge: "Contrat :",
      },
      portalLink: "Copier le lien espace client",
      portalCopied: "Lien espace client copié !",
      reviewLink: "Copier le lien avis (à envoyer au client)",
      reviewLinkCopied: "Lien avis copié !",
      reviewSms: "Copier le message avis prêt à envoyer",
      reviewSmsCopied: "Message avis copié — collez-le dans SMS/WhatsApp !",
      bizCard: {
        title: "Carte de visite",
        hint: "Format 85×55 mm — le QR code amène directement sur le site. Distribuez-la à chaque rendez-vous !",
        role: "Conseiller Orange & Eneco",
        support: "Support après-vente",
        tagline: "Packs télécom & énergie — comparez et économisez en ligne",
        scan: "Scannez-moi",
        download: "Télécharger la carte",
        print: "Imprimer",
      },

      qrCard: {
        title: "Carte avis QR (à imprimer)",
        hint: "Format A6 — à remettre au client après la signature : il scanne et laisse son avis.",
        download: "Télécharger la carte",
        print: "Imprimer",
      },
      googleRating: {
        title: "Note Google (badge sur le site)",
        hint: "Entrez votre note Google Business — un badge apparaîtra dans la section Avis du site.",
        rating: "Note (ex: 4.9)",
        count: "Nb d'avis",
        url: "Lien Google Business (optionnel, https://…)",
        save: "Enregistrer",
        saved: "Note Google enregistrée !",
        failed: "Enregistrement impossible, vérifiez les valeurs.",
      },
      traffic: {
        title: "Trafic du site (14 jours)",        visits: "visites",
        leads: "leads",
        conversion: "conversion",
        topSections: "Sections les plus vues",
        apollo: "Visites Apollo",
        sections: {
          services: "Services",
          offers: "Offres & tarifs",
          calculator: "Calculateur de pack",
          energy: "Simulateur Eneco",
          reviews: "Avis clients",
          contact: "Contact",
          referral: "Parrainage",
          soho: "Pro / SoHo",
          about: "À propos",
          manifesto: "Manifesto",
        },
      },
      pulse: {
        title: "Satisfaction clients (pulse 30 jours)",
        hint: "{n} client(s) sondé(s) un mois après conversion — leurs réponses en un clic :",
        good: "Tout va bien",
        meh: "Bof",
        bad: "Un souci",
      },
      referralPost: {
        title: "Image parrainage à partager",
        hint: "Format story 1080×1920 — idéal statut WhatsApp pour expliquer le −5% à vie.",
        download: "Télécharger l'image",
      },
      apollo: {
        title: "Prospection Apollo",
        notConfigured: "Apollo n'est pas encore connecté. Créez une clé API dans Apollo (Settings → Integrations → API Keys, avec permissions People Search, People Enrichment et Contacts) puis collez-la dans le chat pour activer la prospection et la synchro des leads.",
        hint: "Recherchez des prospects (indépendants, gérants…) et importez-les comme leads. Les leads du site sont aussi synchronisés vers Apollo automatiquement.",
        titlePh: "Fonction (ex : gérant, indépendant, manager…)",
        locationPh: "Lieu (ex : Belgium, Liège)",
        search: "Rechercher",
        import: "Importer",
        importedShort: "Importé",
        imported: "Prospect importé comme lead !",
        importedEmail: "Prospect importé — email trouvé via Apollo !",
        already: "Déjà importé.",
        noResults: "Aucun résultat — élargissez la recherche.",
        failed: "Erreur Apollo — vérifiez la clé API et votre plan.",
        seqTitle: "Séquence automatique",
        seqHint: "Les prospects importés depuis Apollo sont automatiquement inscrits dans cette séquence pour recevoir vos emails de suivi.",
        seqNoMaster: "Les séquences nécessitent une clé API « Master » Apollo (Settings → Integrations → API Keys → cochez « Set as master key »).",
        seqNone: "Aucune séquence trouvée — créez d'abord une séquence dans Apollo (Engage → Sequences).",
        seqSequence: "Choisir une séquence…",
        seqMailbox: "Boîte d'envoi…",
        seqAuto: "Inscription auto",
        seqSave: "Enregistrer",
        seqSaved: "Configuration séquence enregistrée !",
        statsActive: "Active",
        statsPaused: "En pause",
        statsSteps: "étapes",
        statsDelivered: "Envoyés",
        statsOpened: "Ouverts",
        statsClicked: "Cliqués",
        statsReplied: "Réponses",
        bulkAll: "Tout importer",
        bulkDone: "{n} prospects importés ({e} emails trouvés) — inscrits dans la séquence !",
        autoTitle: "Prospection auto-pilote",
        autoHint: "Chaque jour, le système importe automatiquement de nouveaux prospects Apollo selon vos critères et les inscrit dans la séquence.",
        autoEnabled: "Activé",
        autoPerDay: "/jour",
        autoSaved: "Auto-pilote enregistré !",
        autoRun: "Lancer maintenant",
        autoRan: "Auto-pilote exécuté : {n} prospects importés !",
        autoStarted: "Auto-pilote lancé — les nouveaux prospects arrivent dans quelques minutes.",
        autoLast: "Dernier run",
        autoImported: "importés",
        autoEmails: "emails",
      },
      regions: {
        title: "Leads par région",        brussels: "Bruxelles",
        wallonia: "Wallonie",
        flanders: "Flandre",
        unknown: "Sans code postal",
        leads: "leads",
        converted: "convertis",
      },
      offerHistory: {
        title: "Historique des modifications",        created: "créée",
        updated: "modifiée",
        deleted: "supprimée",
        on: "activée",
        off: "désactivée",
        fields: {
          name: "Nom",
          price: "Prix",
          detail_fr: "Description FR",
          detail_en: "Description EN",
          promo_until: "Fin de promo",
          active: "Statut",
          category: "Catégorie",
        },
      },
      appointments: {
        title: "Rendez-vous téléphoniques",
        delete: "Supprimer",
        empty: "Aucun rendez-vous à venir.",
        blockTitle: "Bloquer des créneaux (indisponibilités)",
        blockAllDay: "Toute la journée",
        blockAdd: "Bloquer",
        blockRemove: "Débloquer",
        blockWeekly: "Jour de repos hebdo :",
        weekdays: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        vacationTitle: "Mode vacances",
        vacationOn: "En congé jusqu'au",
        vacationEnable: "Activer",
        vacationDisable: "Désactiver",
        vacationHint: "Les réservations reprennent le lendemain de cette date.",
      },
      pendingReviews: {
        title: "Avis en attente de validation",
        approve: "Publier",
        reject: "Refuser",
      },
      reviewShare: {
        title: "Partager un avis en image",
        download: "Télécharger l'image (1080×1080)",
      },
      billAI: {
        title: "Analyse facture IA",
        savings: "économie ≈",
        perMonth: "/mois",
        analyze: "Analyser la facture (IA)",
        analyzing: "Analyse en cours…",
        failed: "Analyse impossible, réessayez.",
      },
      waiting: { today: "aujourd'hui", days: "j d'attente" },
      sort: { newest: "Plus récents d'abord", oldest: "Plus anciens d'abord" },
      qr: {
        title: "Carte QR de parrainage",
        subtitle: "Imprimez cette carte : le QR ouvre votre site avec le champ parrainage pré-rempli.",
        refName: "Nom du client parrain (optionnel)",
        print: "Imprimer la carte",
        scan: "Scannez pour votre offre",
        back: {
          services: ["Mobile 5G Orange", "Internet + TV", "Électricité & gaz Eneco"],
          offerTitle: "Offre de parrainage",
          offer: "-5% par mois à vie sur votre abonnement mobile par référence qui souscrit un mobile Orange. 20 références = 100% de réduction sur un des numéros de votre facture !",
        },
      },
      search: "Rechercher nom, téléphone, e-mail…",
      snooze: {
        title: "Reporter le rappel au",
        save: "Reporter",
        clear: "Annuler le report",
        until: "Reporté au",
        expired: "À rappeler",
      },
      chart: { title: "Leads vs conversions — 6 derniers mois", leads: "Leads", converted: "Convertis", revenue: "€/mois gagnés" },
      sims: { title: "Packs les plus simulés", total: "simulations", cta: "clics offre", },
      promoPost: {
        title: "Post promo de la semaine",
        subtitle: "Générez une image prête à partager en statut WhatsApp ou sur les réseaux — toujours à jour avec vos offres.",
        download: "Télécharger l'image",
        overlineText: "PROMO DU MOMENT",
        fmtStory: "Story (9:16)",
        fmtSquare: "Post Insta/FB (carré)",
        themes: {
          auto: "Auto",
          standard: "Standard",
          rentree: "Rentrée",
          blackfriday: "Black Friday",
          fetes: "Fêtes",
          ete: "Été",
        },
        hintSquare: "Format 1080×1080 — idéal publication Instagram et Facebook.",
        validUntil: "Valable jusqu'au",
        hint: "Format 1080×1920 — idéal statut WhatsApp, story Instagram/Facebook.",
        captionTitle: "Légende prête à copier",
        copy: "Copier le texte",
        copied: "Texte copié !",
      },
      value: { suffix: "€/mois", title: "Valeur mensuelle du contrat" },
      export: "Exporter CSV",
      tabs: { leads: "Leads", offers: "Offres & tarifs", referrals: "Parrainages", reviews: "Avis", blog: "Blog", prospection: "Prospection" },
      notes: {
        title: "Notes de suivi",
        placeholder: "Ajouter une note d'appel…",
        add: "Ajouter",
        empty: "Aucune note pour ce lead.",
      },
      referrals: {
        subtitle: "5% de réduction par mois à vie par référence convertie — 20 références = 100% sur un des numéros de la facture mobile.",
        cols: { referrer: "Parrain", total: "Références", converted: "Converties", discount: "Réduction acquise" },
        empty: "Aucun lead parrainé pour le moment.",
      },
      reviews: {
        subtitle: "Ces avis s'affichent sur la page d'accueil.",
        add: "Ajouter un avis",
        name: "Nom du client",
        text: "Texte de l'avis",
        save: "Enregistrer",
        cancel: "Annuler",
        empty: "Aucun avis.",
      },
      offers: {
        subtitle: "Ces offres alimentent le chatbot IA en direct — modifiez-les à tout moment.",
        add: "Ajouter une offre",
        save: "Enregistrer",
        cancel: "Annuler",
        name: "Nom de l'offre",
        price: "Prix",
        detailFr: "Détail (FR)",
        detailEn: "Détail (EN)",
        activeLabel: "Active",
        inactiveLabel: "Désactivée",
        orange: "Orange Belgium",
        eneco: "Eneco",
        empty: "Aucune offre dans cette catégorie.",
        promoUntil: "Promo jusqu'au :",
        promoExpired: "Promo expirée",
        promoActive: "promo jusqu'au",
        expiredAlert: "promo(s) expirée(s) — mettez à jour ces offres pour éviter d'afficher des prix obsolètes.",
      },
    },
  },
  en: {
    nav: {
      services: "Services",
      offers: "Pricing",
      why: "Why me",
      about: "About",
      contact: "Contact",
      blog: "Advice",
      cta: "Get called back",
    },
    hero: {
      overline: "Smart SN · Independent Orange Belgium & Eneco partner",
      line1: "Your connection.",
      line2: "Your energy.",
      line3: "One expert.",
      sub: "For 10 years, I've been guiding Belgian households to Orange's best mobile, internet and TV subscriptions — and to smarter energy with Eneco.",
      cta1: "Get my free offer",
      cta2: "Explore services",
      trustPartner: "Official Orange & Eneco partner",
      trustReviews: "Google reviews",
      stats: [
        { v: "10+", l: "years of experience" },
        { v: "2", l: "premium providers" },
        { v: "100%", l: "personal follow-up" },
      ],
    },
    exitIntent: {
      title: "Wait, one second!",
      sub: "Sam calls you back for free within 24h with the best offer for you — no commitment.",
      name: "Your first name",
      phone: "Your number",
      cta: "Call me back for free",
      no: "No thanks, I'll keep browsing",
      thanks: "Got it! Sam will call you back within 24h. Talk soon 👋",
    },
    marquee: ["Orange Belgium", "Eneco", "Internet & 5G", "Mobile + Internet packs", "Green energy", "Independent advice"],
    manifesto: {
      overline: "The manifesto",
      title: "Three reasons to trust me",
      chapters: [
        {
          n: "01",
          title: "Expertise",
          text: "Ten years in the field with Smart SN, an Orange Belgium partner. I know every pack, every option, every promotion — and above all, the one that fits you.",
        },
        {
          n: "02",
          title: "Independence",
          text: "I'm not a call centre. I objectively compare telecom and energy offers to give you the most cost-effective solution, no corporate script.",
        },
        {
          n: "03",
          title: "Proximity",
          text: "Based in Belgium, I speak French and English — before, during and after you sign. One single point of contact, directly reachable.",
        },
      ],
    },
    services: {
      overline: "What I sell",
      title: "Telecom & energy, combined",
      cta: "Request an offer",
      orange: {
        tag: "Orange Belgium",
        title: "Mobile, Internet & TV",
        desc: "5G mobile subscriptions, ultra-fast internet and TV brought together in combo packs that lower your bill.",
        bullets: ["5G mobile subscriptions", "Ultra-fast internet", "TV & entertainment", "Mobile + Internet + TV packs"],
      },
      eneco: {
        tag: "Eneco",
        title: "Electricity & Gas",
        desc: "Clear, green and competitive energy contracts for your home. I compare and set up the best tariff for you.",
      },
      small: [
        { title: "5G Mobile", desc: "Generous data, award-winning Belgian network." },
        { title: "Internet + TV", desc: "Ultra-fast internet, powerful wifi and full entertainment." },
        { title: "Green energy", desc: "Electricity and gas at the best current rate." },
      ],
      whyOrange: {
        title: "Why choose Orange?",
        points: [
          "A fast and reliable network",
          "Competitive prices",
          "A human, responsive and personalised customer service",
          "Dedicated support directly from me throughout the process",
        ],
      },
    },
    offersSection: {
      overline: "Pricing",
      title: "Current offers",
      sub: "Live indicative prices — I lock in the best promotion the moment you sign.",
      orange: "Orange Belgium",
      eneco: "Eneco",
      cta: "Get this offer",
      note: "Prices change often: I confirm the best current rate during our call.",
      countdownLabel: "Promos valid until",
      endsIn: "Ends in",
    },
    calculator: {
      overline: "Simulator",
      title: "Build your pack",
      sub: "Pick your internet and mobile — every current promo and benefit is applied automatically.",
      internet: "Internet",
      mobile: "Mobile",
      mixHint: "mix plans freely",
      base: "List price",
      advantage: "Multi-product benefit",
      lifetime: "FOR-LIFE promos",
      temp: "Temporary promos",
      perMonth: "/mo",
      forLife: "price guaranteed FOR LIFE",
      during: "for",
      months: "months",
      then: "then",
      save: "You save",
      cards: "Number of SIM cards",
      multiCardNote: "Multi-product benefit applied on every mobile card in the pack!",
      compareCatalog: "Catalogue price",
      compareDeal: "Your FOR-LIFE price",
      compareSave: "You save €{y}/year — for life!",
      fixed: "Fixed phone line (optional)",
      fixedNone: "No fixed line",
      fixedName: "Fixed line",
      fixedDetail: "Unlimited calls to Belgian landlines",
      forLifeShort: "FOR LIFE",
      tv: "Television",
      tvNone: "No TV",
      tvNoneDetail: "Internet + mobile only",
      promoPeriod: "promo period",
      note: "Extra SIM cards and TV options included in the calculation — final price confirmed by Sam for your address and available network.",
      cta: "Get this deal",
      share: "Share on WhatsApp",
      shareText: "Check out the pack I simulated at Smart Telecom Advisor:",
      copyLink: "Copy link",
      linkCopied: "Pack link copied!",
    },
    enecoTeaser: {
      overline: "Energy",
      title: "What if you paid less for your energy?",
      text: "Enter your annual consumption to get an instant first Eneco estimate (100% green electricity & gas). Sam then fine-tunes the simulation for free with the exact rates for your region.",
      free: "Free simulation, no strings attached",
      cta: "Get my precise simulation",
      modeBoth: "Electricity + Gas",
      modeElec: "Electricity",
      modeGas: "Gas",
      elecLabel: "Electricity (kWh/year)",
      gasLabel: "Gas (kWh/year)",
      meterLabel: "Electricity meter type",
      meterMono: "Single-rate",
      meterBi: "Dual-rate (day / night)",
      meterBiShort: "dual-rate",
      dayLabel: "Day (kWh/yr)",
      nightLabel: "Night / weekend (kWh/yr)",
      nightHint: "Cheaper night rate (~12 c€/kWh)",
      solarLabel: "Solar panels",
      injLabel: "Grid injection (kWh/yr)",
      injHint: "Injection credit ~4 c€/kWh (already deducted from the total)",
      injLine: "Solar injection",
      avgElec: "Belgian average: 3,500 kWh/yr",
      avgGas: "Belgian average: 17,000 kWh/yr",
      result: "Your Eneco estimate",
      elecLine: "Electricity",
      gasLine: "Gas",
      perMonth: "/mo",
      yr: "yr",
      feeNote: "€65/yr fee per energy included",
      tariffFix: "Fix One · fixed price 1 yr",
      tariffFlex: "Flex One · variable price",
      sohoLabel: "Self-employed / SOHO",
      feeNoteSoho: "€95/yr SOHO fee per energy included",
      promoBanner: "🔥 October promo: −€100/EAN on Fix One, −€50/EAN on Flex One (contracts signed 1–31/10) — stackable elec + gas!",
      promoShort: "October promo",
      promoLine: "October promo (−€{a} per EAN)",
      firstYear: "1st year ≈ €{y}, i.e. €{m}/month",
      currentLabel: "What you currently pay (€/month — optional)",
      cpLabel: "Postal code (Belgium)",
      cpPlaceholder: "E.g. 1000, 4000, 9000…",
      cpInvalid: "Invalid Belgian postal code (1000–9999).",
      regionLabel: "Zone:",
      regionNote: "regional network tariffs applied",
      regions: { brussels: "Brussels", wallonia: "Wallonia", flanders: "Flanders" },
      currentPlaceholder: "e.g. 180",
      currentShort: "currently",
      saving: "Potential savings: ≈ €{y}/year (€{m}/month)!",
      noSaving: "Your current rate already looks competitive — Sam checks for free whether Eneco can do better.",
      disclaimer: "Indicative estimate (energy + fee, regional network tariffs estimated from your postal code, excluding VAT). Sam provides the exact simulation for free, based on your bill.",
    },
    booking: {
      title: "Book a call",
      subtitle: "Pick the moment that suits you — Sam calls you, it's free.",
      name: "Your name",
      phone: "Your phone",
      email: "E-mail (optional — to get a reminder before the call)",
      cta: "Confirm my appointment",
      booking: "Booking…",
      success: "Noted! Sam will call you",
      invalid: "Pick a slot and enter your name + phone.",
      taken: "That slot was just taken, please pick another.",
      failed: "Booking failed, please retry.",
      vacation: "Sam is on holiday until {d} — pick a slot after his return, or leave a message via the form.",
    },
    soho: {
      overline: "Self-employed & VAT",
      title: "Exclusive advantages for professionals",
      text: "Got a VAT number? Enjoy offers reserved for the self-employed and small businesses — with the same human, personalised service throughout your contract.",
      points: [
        "My Comfort Service free for 12 months: tailored optimisation of your internet connection",
        "Multi-product benefit available with your Mobile + Internet pack",
        "One dedicated contact for your telecom and your energy",
      ],
      cta: "Let's talk about your business",
    },
    testimonials: {
      overline: "Client reviews",
      title: "They trust me",
      leaveTitle: "Are you a client? Leave a review",
      yourName: "Your name",
      yourReview: "Your experience with Sam…",
      submit: "Send my review",
      thanks: "Thank you! Your review will be published after Sam's approval.",
      moderation: "Reviews are approved before publication.",
      photoLabel: "Add a photo (optional)",
      photoUploading: "Uploading…",
      photoAttached: "Photo added ✓",
      videoLabel: "Add a video (optional)",
      videoUploading: "Uploading video…",
      videoAttached: "Video added ✓",
      videoTooBig: "Video too large (max 60MB)",
      videoWall: "Video reviews",
      googleOn: "on Google",
      googleReviews: "reviews",
    },
    referral: {
      overline: "Referral programme",
      title: "Refer people around you. Save up to -100%.",
      text: "Exclusive discount of 5% off your mobile subscription, per month and for life, for each reference who signs up for an Orange mobile product. And as always — human, personalised service throughout the duration of your contract.",
      per: "per reference who buys an Orange mobile product",
      max: "off with 20 references",
      highlight: "20 references = 100% off one of the numbers on your mobile bill!",
      cta: "I want in",
      shareLabel: "Share the site with your circle:",
      shareText: "Check out Smart Telecom Advisor — the best Orange subscriptions (mobile, internet, TV) and Eneco energy, with a dedicated advisor:",
      shareWhatsapp: "Share on WhatsApp",
      shareEmail: "Share by email",
      shareSubject: "Worth a look: Smart Telecom Advisor",
    },
    about: {
      overline: "About",
      title: "10 years of trust with Smart SN",
      text: "I'm Sam, an independent advisor within Smart SN, a branch of Orange Belgium, for 10 years. My job: find every Belgian client the best telecom and energy combination — Orange for connectivity, Eneco for electricity and gas.",
      points: ["Certified independent advisor", "Service in French & English", "Human, personalised service throughout your contract"],
    },
    form: {
      overline: "Contact",
      title: "Let's talk about your offer",
      sub: "Leave your details — I'll call you back within 24h with a concrete proposal.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      city: "City",
      postal: "Postal code (e.g. 4000)",
      interest: "I'm interested in",
      options: {
        mobile: "Mobile subscription",
        pack: "Internet + TV pack",
        energy: "Electricity / Gas (Eneco)",
        both: "Telecom + Energy",
        other: "Other / Not sure yet",
      },
      message: "Your message (optional)",
      referredBy: "Referred by (client name — optional)",
      simLabel: "Simulated pack attached",
      responseBadge: "Average callback: under {h}h",
      billLabel: "Attach your energy bill (optional — PDF or photo)",
      billUploading: "Uploading…",
      billError: "Upload failed, please retry.",
      billAnalyzing: "Analyzing your bill…",
      billTeaser: "Good news: you could save ≈ €{x}/month with Eneco! Sam will confirm it during his call.",
      submit: "Send my request",
      sending: "Sending…",
      successTitle: "Thank you!",
      successText: "Your request has been received. I'll get back to you very soon with a tailor-made offer.",
      again: "Send another request",
      error: "Something went wrong. Please try again.",
      phoneDirect: "Rather talk directly? The form only takes a minute.",
    },
    chat: {
      title: "Smart TA Assistant",
      subtitle: "Instant answers · FR & EN",
      welcome: "Hello! I can tell you about Orange offers (mobile, internet, TV) and Eneco (electricity, gas). What are you looking for?",
      placeholder: "Type your message…",
    },
    seo: {
      title: "Your Orange Belgium & Eneco advisor across Belgium",
      h1: "Orange Belgium internet + mobile packs",
      p1: "As an independent Orange Belgium distributor, I compare mobile, internet, TV and fixed-line subscriptions for you. Enjoy the current promo with −€15/month FOR LIFE on Livebox Giga internet, free number portability and an operator switch with zero paperwork. Free online pack simulation in 2 minutes.",
      h2: "Eneco electricity & gas simulation",
      p2: "Compare your energy bill with Eneco tariffs adapted to your region: free electricity and gas simulation in Belgium based on your postal code, meter type (single or dual rate) and solar panels. Switching energy suppliers is free, without interruption, and I handle everything.",
      h3: "100% free independent telecom advisor",
      p3: "Fully free service in Brussels, Wallonia and Flanders: analysis of your telecom or energy bill, phone appointment within 24h and personal follow-up after signup. Cut your telecom and energy bills without changing your habits — in French or English.",
    },
    blog: {
      metaTitle: "Telecom & energy advice Belgium — Blog | Smart Telecom Advisor",
      metaDesc: "Practical guides to pay less: choosing your Orange pack, simulating Eneco electricity and gas, cutting your telecom and energy bills in Belgium.",
      overline: "Blog & advice",
      title: "Advice to pay less",
      subtitle: "Practical telecom & energy guides for Belgium: Orange packs, Eneco simulation and tips to cut your bills.",
      read: "5 min read",
      back: "Back to site",
      ctaBtn: "Start my free simulation",
      more: "Also worth reading",
    },


    footer: {
      tagline: "Independent telecom & energy advisor — Belgium",
      agent: "Agent area",
      hours: "Mon–Sat · 9:00–19:00",
      support: "After-sales support",
      googleReviews: "Our Google reviews",
      rights: "© 2026 Smart TA. All rights reserved.",
      disclaimer: "Smart TA is an independent partner of Orange Belgium. Orange and Eneco are trademarks of their respective owners.",
    },
    login: {
      title: "Agent area",
      sub: "Sign in to manage your leads",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      loading: "Signing in…",
      error: "Invalid credentials. Please try again.",
      back: "Back to site",
    },
    dash: {
      title: "Dashboard",
      subtitle: "Your leads, qualified by AI",
      logout: "Log out",
      refresh: "Refresh",
      stats: { total: "Total leads", fresh: "New", hot: "Hot leads", converted: "Converted" },
      cols: { client: "Client", contact: "Contact", interest: "Interest", score: "AI Score", summary: "AI Analysis", status: "Status", actions: "" },
      statuses: { new: "New", contacted: "Contacted", converted: "Converted", lost: "Lost" },
      empty: "No leads yet. Share your site!",
      pending: "Analyzing…",
      scores: { hot: "Hot", warm: "Warm", cold: "Cold", pending: "…" },
      nextAction: "Suggested action",
      delete: "Delete",
      referredBy: "Referred by",
      viaChat: "via chat",
      hotReply: "replied",
      bill: "Bill",
      pdfBrief: "PDF brief",
      proposalPdf: "Client proposal (PDF)",
      sendProposal: "Email the proposal",
      proposalSent: "Proposal sent to",
      proposalSentOn: "Sent on",
      proposalFailed: "Send failed, please retry.",
      winRates: {
        title: "Conversion rates",
        sources: "By source",
        interests: "By interest",
        packs: "By simulated pack",
        form: "Form",
        chat: "Chatbot",
        empty: "No data yet",
      },
      revenue: {
        title: "Recurring revenue",
        mrr: "Current monthly value",
        perMonth: "/mo",
        perYear: "/yr",
        tooltip: "Cumulative value",
        empty: "Add a €/month value to your converted leads (Status column) to track your revenue.",
        goalTitle: "Monthly goal",
        noGoal: "Set a monthly goal to track your progress.",
        goalPlaceholder: "e.g. 100",
        goalSave: "Set",
      },
      importCsv: "Import CSV",
      importHint: "Columns: name, phone, email, city, value, status",
      importDone: "client(s) imported",
      importDupes: "duplicate(s) skipped",
      importFailed: "Import failed, check the CSV file.",
      details: {
        birthday: "Birthday (automatic wishes)",
        contractEnd: "Contract end (reminder 30 days before)",
        failed: "Save failed.",
      },
      renewal: {
        badge: "Contract:",
      },
      portalLink: "Copy client portal link",
      portalCopied: "Client portal link copied!",
      reviewLink: "Copy review link (send to client)",
      reviewLinkCopied: "Review link copied!",
      reviewSms: "Copy ready-to-send review message",
      reviewSmsCopied: "Review message copied — paste it into SMS/WhatsApp!",
      bizCard: {
        title: "Business card",
        hint: "85×55 mm format — the QR code leads straight to the website. Hand it out at every meeting!",
        role: "Orange & Eneco advisor",
        support: "After-sales support",
        tagline: "Telecom & energy packs — compare and save online",
        scan: "Scan me",
        download: "Download card",
        print: "Print",
      },

      qrCard: {
        title: "Review QR card (printable)",
        hint: "A6 format — hand it to the client after signing: they scan and leave a review.",
        download: "Download card",
        print: "Print",
      },
      googleRating: {
        title: "Google rating (site badge)",
        hint: "Enter your Google Business rating — a badge will appear in the site's Reviews section.",
        rating: "Rating (e.g. 4.9)",
        count: "Review count",
        url: "Google Business link (optional, https://…)",
        save: "Save",
        saved: "Google rating saved!",
        failed: "Could not save, check the values.",
      },
      traffic: {
        title: "Site traffic (14 days)",
        visits: "visits",
        leads: "leads",
        conversion: "conversion",
        topSections: "Most viewed sections",
        apollo: "Apollo visits",
        sections: {
          services: "Services",
          offers: "Offers & pricing",
          calculator: "Pack calculator",
          energy: "Eneco simulator",
          reviews: "Client reviews",
          contact: "Contact",
          referral: "Referral",
          soho: "Pro / SoHo",
          about: "About",
          manifesto: "Manifesto",
        },
      },
      pulse: {
        title: "Client satisfaction (30-day pulse)",
        hint: "{n} client(s) surveyed one month after conversion — their one-tap answers:",
        good: "All good",
        meh: "Meh",
        bad: "An issue",
      },
      referralPost: {
        title: "Shareable referral image",
        hint: "1080×1920 story format — perfect WhatsApp status to explain the −5% for life.",
        download: "Download image",
      },
      apollo: {
        title: "Apollo prospecting",
        notConfigured: "Apollo is not connected yet. Create an API key in Apollo (Settings → Integrations → API Keys, with People Search, People Enrichment and Contacts permissions) then paste it in the chat to activate prospecting and lead sync.",
        hint: "Search prospects (business owners, freelancers…) and import them as leads. Site leads are also synced to Apollo automatically.",
        titlePh: "Job title (e.g. owner, manager…)",
        locationPh: "Location (e.g. Belgium, Liège)",
        search: "Search",
        import: "Import",
        importedShort: "Imported",
        imported: "Prospect imported as a lead!",
        importedEmail: "Prospect imported — email found via Apollo!",
        already: "Already imported.",
        noResults: "No results — broaden the search.",
        failed: "Apollo error — check the API key and your plan.",
        seqTitle: "Auto sequence",
        seqHint: "Prospects imported from Apollo are automatically enrolled in this sequence to receive your follow-up emails.",
        seqNoMaster: "Sequences require an Apollo \"Master\" API key (Settings → Integrations → API Keys → check \"Set as master key\").",
        seqNone: "No sequence found — first create a sequence in Apollo (Engage → Sequences).",
        seqSequence: "Choose a sequence…",
        seqMailbox: "Sending mailbox…",
        seqAuto: "Auto-enroll",
        seqSave: "Save",
        seqSaved: "Sequence configuration saved!",
        statsActive: "Active",
        statsPaused: "Paused",
        statsSteps: "steps",
        statsDelivered: "Sent",
        statsOpened: "Opened",
        statsClicked: "Clicked",
        statsReplied: "Replies",
        bulkAll: "Import all",
        bulkDone: "{n} prospects imported ({e} emails found) — enrolled in the sequence!",
        autoTitle: "Auto-pilot prospecting",
        autoHint: "Every day, the system automatically imports new Apollo prospects matching your criteria and enrolls them in the sequence.",
        autoEnabled: "Enabled",
        autoPerDay: "/day",
        autoSaved: "Auto-pilot saved!",
        autoRun: "Run now",
        autoRan: "Auto-pilot executed: {n} prospects imported!",
        autoStarted: "Auto-pilot started — new prospects will appear in a few minutes.",
        autoLast: "Last run",
        autoImported: "imported",
        autoEmails: "emails",
      },
      regions: {
        title: "Leads by region",
        brussels: "Brussels",
        wallonia: "Wallonia",
        flanders: "Flanders",
        unknown: "No postal code",
        leads: "leads",
        converted: "converted",
      },
      offerHistory: {
        title: "Change history",
        created: "created",
        updated: "updated",
        deleted: "deleted",
        on: "active",
        off: "inactive",
        fields: {
          name: "Name",
          price: "Price",
          detail_fr: "Description FR",
          detail_en: "Description EN",
          promo_until: "Promo end",
          active: "Status",
          category: "Category",
        },
      },
      appointments: {
        title: "Phone appointments",
        delete: "Delete",
        empty: "No upcoming appointments.",
        blockTitle: "Block slots (unavailability)",
        blockAllDay: "All day",
        blockAdd: "Block",
        blockRemove: "Unblock",
        blockWeekly: "Weekly day off:",
        weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        vacationTitle: "Vacation mode",
        vacationOn: "On holiday until",
        vacationEnable: "Enable",
        vacationDisable: "Disable",
        vacationHint: "Bookings resume the day after this date.",
      },
      pendingReviews: {
        title: "Reviews awaiting approval",
        approve: "Publish",
        reject: "Reject",
      },
      reviewShare: {
        title: "Share a review as an image",
        download: "Download image (1080×1080)",
      },
      billAI: {
        title: "AI bill analysis",
        savings: "savings ≈",
        perMonth: "/mo",
        analyze: "Analyze bill (AI)",
        analyzing: "Analyzing…",
        failed: "Analysis failed, please retry.",
      },
      waiting: { today: "today", days: "d waiting" },
      sort: { newest: "Newest first", oldest: "Oldest waiting first" },
      qr: {
        title: "Referral QR card",
        subtitle: "Print this card: the QR opens your site with the referral field pre-filled.",
        refName: "Referring client name (optional)",
        print: "Print the card",
        scan: "Scan for your offer",
        back: {
          services: ["Orange 5G mobile", "Internet + TV", "Eneco electricity & gas"],
          offerTitle: "Referral offer",
          offer: "-5% per month for life on your mobile subscription per reference who signs an Orange mobile plan. 20 references = 100% off one of the numbers on your bill!",
        },
      },
      search: "Search name, phone, email…",
      snooze: {
        title: "Snooze callback until",
        save: "Snooze",
        clear: "Clear snooze",
        until: "Snoozed until",
        expired: "Call back now",
      },
      chart: { title: "Leads vs conversions — last 6 months", leads: "Leads", converted: "Converted", revenue: "€/mo earned" },
      sims: { title: "Most simulated packs", total: "simulations", cta: "offer clicks", },
      promoPost: {
        title: "Weekly promo post",
        subtitle: "Generate a ready-to-share image for WhatsApp status or socials — always up to date with your offers.",
        download: "Download image",
        overlineText: "DEAL OF THE MOMENT",
        fmtStory: "Story (9:16)",
        fmtSquare: "Insta/FB post (square)",
        themes: {
          auto: "Auto",
          standard: "Standard",
          rentree: "Back to school",
          blackfriday: "Black Friday",
          fetes: "Holidays",
          ete: "Summer",
        },
        hintSquare: "1080×1080 format — ideal for Instagram and Facebook feed posts.",
        validUntil: "Valid until",
        hint: "1080×1920 format — perfect for WhatsApp status, Instagram/Facebook stories.",
        captionTitle: "Ready-to-copy caption",
        copy: "Copy text",
        copied: "Text copied!",
      },
      value: { suffix: "€/mo", title: "Monthly contract value" },
      export: "Export CSV",
      tabs: { leads: "Leads", offers: "Offers & pricing", referrals: "Referrals", reviews: "Reviews", blog: "Blog", prospection: "Prospecting" },
      notes: {
        title: "Follow-up notes",
        placeholder: "Add a call note…",
        add: "Add",
        empty: "No notes for this lead yet.",
      },
      referrals: {
        subtitle: "5% discount per month for life per converted reference — 20 references = 100% off one of the numbers on the mobile bill.",
        cols: { referrer: "Referrer", total: "References", converted: "Converted", discount: "Earned discount" },
        empty: "No referred leads yet.",
      },
      reviews: {
        subtitle: "These reviews are displayed on the homepage.",
        add: "Add review",
        name: "Client name",
        text: "Review text",
        save: "Save",
        cancel: "Cancel",
        empty: "No reviews.",
      },
      offers: {
        subtitle: "These offers feed the AI chatbot live — edit them anytime.",
        add: "Add offer",
        save: "Save",
        cancel: "Cancel",
        name: "Offer name",
        price: "Price",
        detailFr: "Detail (FR)",
        detailEn: "Detail (EN)",
        activeLabel: "Active",
        inactiveLabel: "Disabled",
        orange: "Orange Belgium",
        eneco: "Eneco",
        empty: "No offers in this category.",
        promoUntil: "Promo until:",
        promoExpired: "Promo expired",
        promoActive: "promo until",
        expiredAlert: "expired promo(s) — update these offers to avoid showing stale prices.",
      },
    },
  },
};
